/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S7_P1Inputs */

const en_guide_what_is_json_s7_p1 = /** @type {(inputs: Guide_What_Is_Json_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most developers meet JSON long before they read a spec for it. It shows up the first time you call an API and log the response, the first time you open a package.json, or the first time a colleague pastes a config snippet into chat. Getting comfortable reading it quickly pays off across almost every part of modern development.`)
};

const ko_guide_what_is_json_s7_p1 = /** @type {(inputs: Guide_What_Is_Json_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대부분의 개발자는 명세를 읽기 훨씬 전에 JSON을 먼저 만납니다. API를 호출하고 응답을 로그로 찍을 때, package.json을 처음 열 때, 동료가 채팅에 설정 조각을 붙여넣을 때 어김없이 등장하죠. JSON을 빠르게 읽는 데 익숙해지면 현대 개발의 거의 모든 영역에서 도움이 됩니다.`)
};

const ja_guide_what_is_json_s7_p1 = /** @type {(inputs: Guide_What_Is_Json_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多くの開発者は、仕様を読むよりずっと前に JSON に出会います。API を呼んでレスポンスをログに出すとき、package.json を初めて開くとき、同僚が設定の断片をチャットに貼るとき、必ず現れます。JSON を素早く読むことに慣れておくと、現代の開発のほぼあらゆる場面で役立ちます。`)
};

/**
* | output |
* | --- |
* | "Most developers meet JSON long before they read a spec for it. It shows up the first time you call an API and log the response, the first time you open a pac..." |
*
* @param {Guide_What_Is_Json_S7_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s7_p1 = /** @type {((inputs?: Guide_What_Is_Json_S7_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S7_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s7_p1(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s7_p1(inputs)
	return ja_guide_what_is_json_s7_p1(inputs)
});